import React, { Component } from 'react';
import { connect } from 'react-redux';

import MediaQuery from 'react-responsive';
import TextField from 'material-ui/TextField';

import VendorsTable from './VendorsTable';
import VendorsMobile from './VendorsMobile';

import * as vendorsActions from 'actions/vendorsActions';
import { getTranslatedString } from 'helpers/i18n';

export default connect(
  store => ({
    vendors: store.vendors.vendors,
    vendorDetails: store.vendors.vendorDetails,
    vendorDialogIsOpen: store.vendors.vendorDialogIsOpen,
  }),
  vendorsActions
)(
  class AccountsNonGrid extends Component {
    constructor(props) {
      super(props);
      this.state = { filter: 'All', typeFilter: '' };
    }

    componentDidMount = () => {
      this.props.getVendors();
    };

    getFilterType(dataFromChild) {
      this.setState({ filter: dataFromChild });
    }

    getTypeFilterType = e => {
      this.setState({ typeFilter: e.target.value });
    };

    render() {
      const data = this.props.vendors;

      const typing_filter = this.state.typeFilter.toUpperCase();

      const extraFilteredData = data.filter(item => {
        return (
          !typing_filter ||
          item.name.toUpperCase().includes(typing_filter) ||
          item.classification?.toUpperCase()?.includes(typing_filter) ||
          String(item.amount_due).includes(typing_filter)
        );
      });

      return (
        <div ref="transactionsContainer">
          <MediaQuery query="(min-device-width: 750px)">
            <div className="row" style={{ marginTop: '-20px' }}>
              <TextField
                hintText={getTranslatedString('landlordPortal.vendors.filterBy')}
                style={{ fontSize: '13px' }}
                value={this.state.typeFilter}
                onChange={this.getTypeFilterType}
              />
            </div>
            <VendorsTable
              data={extraFilteredData}
              vendorDetails={this.props.vendorDetails}
              vendorDialogIsOpen={this.props.vendorDialogIsOpen}
              openVendorInfoDialog={this.props.openVendorInfoDialog}
              openEditVendorDialog={this.props.openEditVendorDialog}
              closeVendorInfoDialog={this.props.closeVendorInfoDialog}
              deleteVendor={this.props.deleteVendor}
            />
          </MediaQuery>
          <MediaQuery query="(max-device-width: 750px)">
            <VendorsMobile data={extraFilteredData} />
          </MediaQuery>
        </div>
      );
    }
  }
);
